import React, { Component, Fragment, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { fromJS } from "immutable";
import { CategoryGames } from "component/list";
import { CategoryListItem } from "component/listItem";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as CashierIcon } from "assets/icons/cashInOut.svg";
import { ReactComponent as SwitchDevice } from "assets/icons/switchDevice.svg";
import { getTotalPool } from "utils/getTotalpool";
import { isEmpty } from "lodash";
import { withNamespaces } from "react-i18next";
import { InfoAction } from "component/details";

import * as queryString from "query-string";

import "containers/GameAction/styles.scss";

const ACTION_MODAL = "ACTION_MODAL";

class GameAction extends Component {
  constructor(props) {
    super(props);

    this.modalRef = createRef();
    this.modalActionRef = createRef();

    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
    this.onExpandDetails = this._onExpandDetails.bind(this);
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.getDetails = this._getDetails.bind(this);
    this.fetchGameUrl = this._fetchGameUrl.bind(this);
    this.handleScroll = this._handleScroll.bind(this);
    this.fetchRelatedLinks = this._fetchRelatedLinks.bind(this);
    this.handleDescription = this._handleDescription.bind(this);
    this.onClickEventHandler = this._onClickEventHandler.bind(this);
    this.getTotalPool = getTotalPool.bind(this);

    this.state = {
      isLoading: true,
      isLoadingRelated: true,
      loadingGameRel: null,
      details: null,
      relatedLinks: null,
      similarLink: null,
      launchRealLink: null,
      launchDemoLink: null,
      realUrl: null,
      demoUrl: null,
      realLink: null,
      demoLink: null,
      expand: false,
      hasPromotionIcons: null,
      showCategoryLabel: false,
      expandDescription: false,
      jackpotPool: null,
    };
  }

  _getDetails(gameId) {
    this.setState({
      isLoading: true,
      isLoadingRelated: true,
      loadingGameRel: null,
      details: null,
      relatedLinks: null,
      similarLink: null,
      launchRealLink: null,
      launchDemoLink: null,
      realUrl: null,
      demoUrl: null,
      realLink: null,
      demoLink: null,
      expand: false,
      hasPromotionIcons: null,
      showCategoryLabel: false,
    });

    this.props
      .fetchGameDetailsUrl(gameId)
      .then((response) => {
        let link = fromJS(response);
        return this.props.fetchGameDetails(link);
      })
      .then((response) => {
        let details = fromJS(response.payload.data);
        let hasPromotionIcons =
          details.get("hasFreeRounds") ||
          details.get("partOfOnGoingTournament") ||
          details.get("isFeatured") ||
          details.get("isJackpot");
        this.setState({
          details,
          hasPromotionIcons,
        });
        return;
      })
      .then(() => {
        let realLink;

        try {
          realLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "launch.real";
          });
        } catch (err) {}
        this.setState({
          realLink,
        });
      })
      .then(() => {
        let demoLink;
        try {
          demoLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "launch.demo";
          });
          this.setState({
            demoLink,
          });
        } catch (err) {
          return;
        }
      })
      .then(() => {
        this.setState({
          isLoading: false,
          isLoadingRelated: false,
        });
        let relatedLink;
        try {
          relatedLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "related.links";
          });
          let params = {
            nav: this.props.nav,
          };

          return this.fetchRelatedLinks(relatedLink, params);
        } catch (err) {
          return;
        }
      })
      .then(() => {
        this.setState({
          isLoadingRelated: false,
        });
      });
  }

  _fetchRelatedLinks(link, params) {
    return this.props.fetchRelatedLinks(link, params).then((response) => {
      this.setState({
        relatedLinks: fromJS(response),
      });
    });
  }

  async _onClickEventHandler(link) {
    let url;
    const newWindow = window.open("", this.props.gameLaunchTarget); // Open immediately

    this.setState({
      loadingGameRel: link.get("rel"),
    });

    await this.fetchGameUrl(link);

    switch (link.get("rel")) {
      case "launch.real":
        url = this.state.realUrl;
        break;
      case "launch.demo":
        url = this.state.demoUrl;
        break;
      default:
        url = null;
        break;
    }

    if (url) {
      newWindow.location.href = url;
    } else {
      newWindow.close();
    }

    this.setState({
      loadingGameRel: null,
    });
  }

  _fetchGameUrl(link) {
    let params;
    let returnUrl;
    switch (this.state.details.get("launchTarget")) {
      case "_top":
      case "_self":
      case "_parent":
        let urlParams = new URLSearchParams(this.props.location.search);
        let redirectParams = new URLSearchParams();
        let url = `${this.props.location.pathname}?${urlParams.toString()}`;
        redirectParams.set("redirect", btoa(encodeURIComponent(url)));
        returnUrl = `${window.location.origin}/${
          this.props.match.params.locale
        }/${
          this.props.match.params.sessionId
        }/exit?${redirectParams.toString()}`;
        break;
      default:
        returnUrl = `${window.location.origin}/${
          this.props.match.params.locale
        }/${this.props.match.params.sessionId}/exit`;
        break;
    }
    params = {
      returnUrl,
    };

    if (this.props.appId) {
      params = {
        returnUrl: `${this.props.appId}://lobby`,
      };
    }

    return this.props
      .fetchGameUrl(link, params)
      .then((response) => {
        if (link.get("rel") === "launch.real") {
          this.setState({
            launchRealLink: link,
            realUrl: response.payload.data.url,
          });
        } else if (link.get("rel") === "launch.demo") {
          this.setState({
            launchDemoLink: link,
            demoUrl: response.payload.data.url,
          });
        }
        return response;
      })
      .catch((err) => {
        this.setState({
          loadingGameRel: null,
        });
      });
  }

  _onGameItemClickHandler(game, rel) {
    this.setState({
      loadingGameRel: null,
    });
    let gameId = game.get("gameId");
    let nav = this.props.link ? this.props.link.get("rel") : null;
    this.props.gameClick(gameId, rel, nav).then((response) => {
      if (response.location) {
        this.props.navigateTo(response.location);
      } else if (response.params) {
        this.props.setGameAction(response.params);
      }
    });
  }

  _onExpandDetails() {
    this.setState({
      expand: !this.state.expand,
    });
  }

  _onCloseClickHandler() {
    this.setState({
      expand: false,
    });
    this.props.fetchBalance();
    let search = queryString.parse(this.props.location.search);
    delete search.gameId;
    delete search.playType;
    delete search.nav;
    this.props.navigateTo(`${this.props.location.pathname}`);
  }

  componentDidMount() {
    if (this.props.gameId) {
      this.getDetails(this.props.gameId);
      //scroll to top
      this.props.showModal(ACTION_MODAL);
      this.setState({
        expand: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.gameActionDetails !== nextProps.gameActionDetails &&
      nextProps.gameActionDetails
    ) {
      if (nextProps.gameActionDetails === null) {
        this.props.hideModal(ACTION_MODAL);
        this.setState({
          expand: false,
        });
      } else {
        this.setState(nextProps.gameActionDetails);
        try {
          let relatedLink = nextProps.gameActionDetails.details
            .get("links")
            .find((link) => {
              return link.get("rel") === "related.links";
            });
          let params = {
            nav: nextProps.gameActionParams.get("nav"),
          };
          this.fetchRelatedLinks(relatedLink, params);
        } catch (err) {}

        this.props.showModal(ACTION_MODAL);
      }
    }

    if (nextProps.gameId !== this.props.gameId) {
      if (nextProps.gameId === undefined || nextProps.gameId === "undefined") {
        this.props.hideModal(ACTION_MODAL);
        this.setState({
          expand: false,
        });
      } else {
        if (
          !this.state.details ||
          this.state.details.getIn(["gameId"]) !== nextProps.gameId
        ) {
          this.getDetails(nextProps.gameId);
        }
        this.props.showModal(ACTION_MODAL);
      }
    }
    if (
      this.state.details &&
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.state.details.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.gameActionDetails !== prevProps.gameActionDetails &&
      this.props.gameActionDetails &&
      this.modalRef.current
    ) {
      this.modalRef.current.scrollTo(0, 0);
    }

    if (
      prevProps.gameId !== this.props.gameId &&
      this.props.gameId &&
      this.modalRef.current
    ) {
      this.modalRef.current.scrollTo(0, 0);
    }
  }

  _handleScroll(event) {
    const { scrollTop } = event.currentTarget;
    if (scrollTop !== 0) {
      this.setState({ showCategoryLabel: true });
    } else {
      this.setState({ showCategoryLabel: false });
    }
  }

  _handleDescription() {
    let btns = document.getElementsByClassName("description-clickable");
    if (btns.length > 1) {
      if (this.state.expandDescription) {
        btns[0].click();
      } else {
        btns[1].click();
      }
      this.setState({ expandDescription: !this.state.expandDescription });
    }
  }

  render() {
    if (!this.props.gameId || !this.props.isMobile || !this.props.playType)
      return null;

    let params = {
      location: this.props.location,
      url: this.state.gameUrl,
      hideSplash: this.props.hideSplash,
      isMobile: this.props.isMobile,
      appId: this.props.appId,
      target: "_self",
    };

    return (
      <div
        className={`game-action modal ${
          this.props.gameId ? "show" : "d-none"
        } expand`}
        onClick={() => {
          if (this.state.loadingGameRel) return;
          this.props.clearGameAction();
        }}
      >
        <div
          className="modal-dialog nopadding"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className="modal-content">
            <div
              className="modal-body nopadding"
              ref={this.modalRef}
              onScroll={this.handleScroll}
            >
              <div className="header-game-action row">
                <button className="col-auto">
                  <PreviousIcon onClick={this.props.history.goBack} />
                </button>
                <div className="col d-flex align-items-center">
                  {this.state.details && (
                    <span
                      className={`details-actions ${
                        this.state.hasPromotionIcons ? "promotional" : ""
                      } ${this.state.showCategoryLabel ? "fade-in" : ""}`}
                      ref={this.actionLabel}
                    >
                      {this.state.details.get("name")}
                    </span>
                  )}
                </div>
                {this.props.showCashier && (
                  <div
                    className="col-auto"
                    onClick={this.props.broadcastCashier}
                  >
                    <CashierIcon />
                  </div>
                )}
                {this.props.showSwitchDevice && (
                  <div
                    className="col-auto switch-icon"
                    onClick={() => {
                      this.props.broadcastSwitchDevice(
                        params,
                        this.props.gameId,
                      );
                    }}
                  >
                    <SwitchDevice />
                  </div>
                )}
                <button className="col-auto">
                  <CloseIcon
                    onClick={this.onCloseClickHandler}
                    disabled={this.state.loadingGameRel !== null}
                  />
                </button>
              </div>
              <div className="header-game-action d-none">
                {this.state.details && (
                  <span
                    className={`details-actions ${
                      this.state.hasPromotionIcons ? "promotional" : ""
                    } ${this.state.showCategoryLabel ? "fade-in" : ""}`}
                    ref={this.actionLabel}
                  >
                    {this.state.details.get("name")}
                  </span>
                )}
                {this.props.showCashier && (
                  <div
                    className="col-auto"
                    onClick={this.props.broadcastCashier}
                  >
                    <CashierIcon />
                  </div>
                )}
                {this.props.showSwitchDevice && (
                  <div
                    className="col-auto switch-icon"
                    onClick={() => {
                      this.props.broadcastSwitchDevice(
                        params,
                        this.props.gameId,
                      );
                    }}
                  >
                    <SwitchDevice />
                  </div>
                )}
                <CloseIcon onClick={this.onCloseClickHandler} />
              </div>
              <div className="image-spacer" />
              <InfoAction
                details={this.state.details}
                imageFormat={this.props.imageFormat}
                isLoading={this.state.isLoading}
                demoLink={this.state.demoLink}
                realLink={this.state.realLink}
                hasPromotionIcons={this.state.hasPromotionIcons}
                currency={this.props.currency}
                jackpotPool={this.state.jackpotPool}
                loadingGameRel={this.state.loadingGameRel}
                gameLaunchTarget={this.props.gameLaunchTarget}
                onGameItemClickHandler={(rel) => {
                  this.onGameItemClickHandler(this.state.details, rel);
                }}
                onClickEventHandler={(link) => {
                  this.onClickEventHandler(link);
                }}
              />
              <Fragment>
                <div className="horizontal-bar"> </div>
                {this.state.relatedLinks &&
                  this.state.relatedLinks.map((route, key) => {
                    let maxCount = 20;

                    let filtersRoute;
                    try {
                      filtersRoute = route.get("links").find((link) => {
                        return link.get("rel").indexOf("filters");
                      });
                    } catch (err) {}

                    let filters;
                    try {
                      filters = this.props.filters.getIn([
                        filtersRoute.get("rel"),
                        "data",
                        "filters",
                      ]);
                    } catch (err) {}

                    let filtersIsLoading;
                    try {
                      filtersIsLoading = this.props.filters.getIn([
                        filtersRoute.get("rel"),
                        "isLoading",
                      ]);
                    } catch (err) {}

                    let sortBy;
                    try {
                      sortBy = this.props.filters.getIn([
                        filtersRoute.get("rel"),
                        "data",
                        "sortBy",
                      ]);
                    } catch (err) {}

                    let games;
                    try {
                      games = this.props.gamesState.getIn([
                        route.get("rel"),
                        "data",
                      ]);
                    } catch (err) {}

                    let page;
                    try {
                      page = games.get("page");
                    } catch (err) {}

                    let isLoading;
                    try {
                      isLoading = this.props.gamesState.getIn([
                        route.get("rel"),
                        "isLoading",
                      ]);
                    } catch (err) {}

                    let isLoadingNext;
                    try {
                      isLoadingNext = this.props.gamesState.getIn([
                        route.get("rel"),
                        "isLoadingNext",
                      ]);
                    } catch (err) {}

                    let hasNextPage;
                    try {
                      hasNextPage = games.get("totalPages") > games.get("page");
                      hasNextPage = hasNextPage
                        ? games.getIn(["items"]).size < maxCount
                        : false;
                    } catch (err) {
                      hasNextPage = true;
                    }

                    return (
                      <CategoryGames
                        key={key}
                        route={route}
                        titleTestId="recommend-header"
                        hasNoFilters={!filtersRoute}
                        refreshList={!filtersIsLoading}
                        itemComponent={CategoryListItem}
                        isMobile={this.props.isMobile}
                        isLoading={isLoading}
                        isLoadingNext={isLoadingNext}
                        hasNextPage={hasNextPage}
                        games={games}
                        sortBy={sortBy}
                        fetchGames={() => {
                          let params = new URLSearchParams();
                          if (filters) {
                            filters.forEach((filter) => {
                              filter.get("values").forEach((value) => {
                                if (value.get("toggled") === true) {
                                  params.append(
                                    filter.get("id"),
                                    value.get("id"),
                                  );
                                }
                              });
                            });
                          }
                          if (sortBy) {
                            params.append("sortBy", sortBy);
                          }

                          return this.props.fetchGames(route, params);
                        }}
                        onGameItemClickHandler={(item) => {
                          let itemObj = fromJS(item);
                          this.onGameItemClickHandler(itemObj, item.playType);
                        }}
                        imageFormat={this.props.imageFormat}
                        onReachEnd={() => {
                          let params = new URLSearchParams();
                          params.append("page", page ? page + 1 : 1);

                          if (filters) {
                            filters.forEach((filter) => {
                              filter.get("values").forEach((value) => {
                                if (value.get("toggled") === true) {
                                  params.append(
                                    filter.get("id"),
                                    value.get("id"),
                                  );
                                }
                              });
                            });
                          }
                          if (sortBy) {
                            params.append("sortBy", sortBy);
                          }

                          return this.props.fetchGames(route, params);
                        }}
                        latestBroadcast={this.props.latestBroadcast}
                        currency={this.props.currency}
                        isOneClickPlayEnabled={this.props.isOneClickPlayEnabled}
                      />
                    );
                  })}
              </Fragment>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let sessionId = state.security.get("sessionId");
  let isMobile = state.window.get("isMobile");
  let { gameId, playType, nav } = queryString.parse(ownProps.location.search);
  let currency = null;
  let latestBroadcast;

  try {
    latestBroadcast = state.serverSentEvent.getIn(["latestBroadcast"]);
  } catch (err) {}

  //app not yet initialized
  if (!sessionId || !isMobile) {
    return {};
  }
  let isRound = false;
  let showCashier;
  let showSwitchDevice;
  let gameLaunchTarget;
  let pType;
  try {
    pType =
      playType === "launch.real" || playType === "launch.demo"
        ? null
        : playType;
  } catch (err) {}
  try {
    gameLaunchTarget = state.links.get("gameLaunchTarget");
  } catch (err) {}
  try {
    isMobile = state.window.get("isMobile");
  } catch (err) {}

  try {
    showCashier = state.profile.get("showCashier");
  } catch (err) {}
  try {
    showSwitchDevice = state.profile.get("showSwitchDevice");
  } catch (err) {}
  try {
    if (
      nav.indexOf("home.recentlyplayed") > -1 ||
      nav.indexOf("play-it-again") > -1
    ) {
      isRound = true;
    }
  } catch (err) {}

  if (!isEmpty(state.links.get("currency"))) {
    currency = state.links.get("currency");
  }

  return {
    nav,
    isMobile,
    isRound,
    gamesState: state.games,
    gameId,
    gameActionDetails: state.game.get("stateDetails"),
    gameActionParams: state.game.get("params"),
    showCashier,
    showSwitchDevice,
    gameLaunchTarget,
    playType: pType,
    imageFormat: state.window.get("imageFormat"),
    locale: state.config.getIn(["locale"]),
    latestBroadcast,
    currency: currency,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchGameDetailsUrl: (gameId) => dispatchProps.fetchGameDetailsUrl(gameId),
    fetchGameDetails: (link, params) =>
      dispatchProps.fetchGameDetails(link, params),
    fetchGameUrl: (link, params) => dispatchProps.fetchGameUrl(link, params),
    fetchRelatedLinks: (route, params) =>
      dispatchProps.fetchRelatedLinks(route, params),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    navigateTo: (path) => ownProps.history.push(`${path}`),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    fetchBalance: () => dispatchProps.fetchBalance(),
    clearGameAction: () => dispatchProps.clearGameAction(),
    onGameLaunch: (params) => dispatchProps.onGameLaunch(params),
    broadcastCashier: () => dispatchProps.broadcastCashier(),
    broadcastSwitchDevice: (params, gameId) =>
      dispatchProps.broadcastSwitchDevice(params, gameId),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
    setGameAction: (params) => dispatchProps.setGameAction(params),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withNamespaces("translation")(GameAction));
